import React from "react";
import Lottie from "react-lottie";

import { connect } from "react-redux";

import { isHorizontalOrientation } from "../../../utils/isHorizontalOrientation";

import imageLoaderDesktop from "./assets/image-loader-desktop.json";
import imageLoaderMobile from "./assets/image-loader-mobile.json";

import "./splashscreen.less";

class SplashScreen extends React.Component {
  constructor(props) {
    super(props);

    this.options = {
      animationData: this.getAnimationData(),
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
        className: "SplashScreen",
      },
      autoplay: true,
      loop: false,
    };

    this.eventListeners = [
      {
        eventName: "complete",
        callback: () => {
          props.handleComplete();
          props.setStatus(false);
        },
      },
    ];
  }

  getAnimationData() {
    if (isHorizontalOrientation()) {
      return imageLoaderDesktop;
    }

    return imageLoaderMobile;
  }

  render() {
    return (
      <Lottie
        options={this.options}
        eventListeners={this.eventListeners}
        isClickToPauseDisabled={true}
      />
    );
  }
}




const mapDispatchToProps = (dispatch) => {
  return {
    setStatus: (status) => {
      dispatch({
        type: "SET_SS_VISIBILITY",
        payload: status,
      });
    },
  };
};
export default connect(null, mapDispatchToProps)(SplashScreen);



// WEBPACK FOOTER //
// ./src/js/components/widgets/splashscreen/splashscreen.jsx